export function getChangeDefaultHomepageModalI18nPrefix(langCode) {
  switch (langCode) {
    case 'app':
      return 'app';
    default:
      return 'setup-guide-components';
  }
}